<template>
  <div class="wrapper">
    <div class="accordion" @click="toggleItem">
      <h2 class="title">
        <slot name="title"></slot>
      </h2>
    <div v-show="show" class="content">
      <slot name="content"></slot>
    </div>
    </div>
    <hr>
  </div>
</template>
<script>
export default {
  components: {},
  data: function() {
    return {
      show: false
    };
  },
  methods: {
    toggleItem: function() {
      this.show = !this.show;
    }
  }
};
</script>
<style scoped>
.wrapper {
  margin: 0 auto;
  width: 100%;
  padding: 10px;
}
.accordion {
  display: flex;
  flex-direction: column;
  cursor: pointer;
    border-left: 4px solid #FFC727;
    padding: 10px 36px;
  margin: 0;
}
hr{
  height: 4px;
  background: #F1F6F9;
  border: none;
  width: 98%;
}
.title {
  margin: 0;
  font-size: 24px;
  color: #4D8EA8;
  font-weight: 500;
}
.content {
    padding-left: 36px;
  text-align: left;
  width: 100%;
  padding: 10px;
}
.text{
  font-weight: 300;
  font-size: 18px;
}

@media (max-width: 480px) {
  .title {
  margin: 0;
  font-size: 18px;
  color: #4D8EA8;
  font-weight: 500;
}
.content {
    padding-left: 36px;
  text-align: left;
  width: 100%;
  padding: 10px;
}
.text{
  font-weight: 300;
  font-size: 16px;
}
}
</style>